import React from "react"
import AOS from "aos"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { checkAccessThankYou } from "./src/utils/thank-you-access";

export const onClientEntry = (props) => {
    AOS.init({
        once: true
    });

    if (AOS) {
        AOS.refresh();
    }

    checkAccessThankYou()
    console.log("gatsby-browser onClientEntry");
}

export const wrapRootElement = ({ element }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_KEY}>
            {element}
        </GoogleReCaptchaProvider>
    )
}


    
